import { render, staticRenderFns } from "./edad.vue?vue&type=template&id=7f7e2d66&"
import script from "./edad.vue?vue&type=script&lang=js&"
export * from "./edad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports